import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { ConfirmationService } from '@app/core/confirmation/confirmation.service';
import { ConfirmationResponse } from '@app/core/confirmation/confirmationResponse.model';
import { ErrorService } from '@app/core/error/error.service';
import { InfoService } from '@app/core/info/info.service';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { User } from '@app/core/user/model/User.model';
import { UserService } from '@app/core/user/user.service';
import { AbstractComponent } from '@app/shared/component/AbstractComponent';
import { ActionCV } from '@app/shared/model/cv/ActionCV.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ChangePassword } from './changePassword.model';
import { PasswordValidatorService } from './password-validator.service';
import { UserCV } from '../user/model/UserCV.model';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends AbstractComponent implements OnInit {

  @Input() modal: boolean;

  detailForm: FormGroup;
  user: User;

  afterLogin = false;
  userCV = new UserCV();

  constructor(
    public authService: AuthService,
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public infoService: InfoService,
    public confirmationService: ConfirmationService,
    public errorService: ErrorService,
    public routeService: Router,
    private userService: UserService,
    private passwordValidator: PasswordValidatorService,
    private spinner: SpinnerService,
    private router: Router,
    private activeModal: NgbActiveModal
  ) {
    super(authService, translateService);
  }

  ngOnInit(): void {
    this.user = this.authService.getUser();
    this.detailForm = this.getDetailForm();
  }

  getDetailForm(): FormGroup {
    // inicializamos el formulario reactivo
    const form: FormGroup = this.detailForm = new FormGroup({
      previousPassword: new FormControl('', { validators: [Validators.required]}),
      password: new FormControl('', { validators: [Validators.required]}),
      repeatpassword: new FormControl('', { validators: [Validators.required]}),
    });

    if (this.afterLogin) {
      this.detailForm.get('previousPassword').setValidators(null);
    }

    if (this.user.type === UserCV.all.TYPE_PORTAL_OCS) {
      this.detailForm.get('password').setValidators([
        Validators.required
      ]);
      this.detailForm.get('repeatpassword').setValidators([
        Validators.required,
        this.passwordValidator.matchPasswords(this.detailForm.get('password'))
      ]);
    } else {
      this.detailForm.get('password').clearValidators();
      this.detailForm.get('repeatpassword').clearValidators();

      this.detailForm.get('password').setValidators([
        Validators.required,
        this.passwordValidator.passwordFormat()
      ]);
      this.detailForm.get('repeatpassword').setValidators([
        Validators.required,
        this.passwordValidator.passwordFormat(),
        this.passwordValidator.matchPasswords(this.detailForm.get('password'))
      ]);
    }
    return form;
  }

  changePassword(): void {
    const previousPassword = this.detailForm.get('previousPassword').value;
    const password = this.detailForm.get('password').value;

    const changePassword = new ChangePassword();
    changePassword.previousPassword = previousPassword;
    changePassword.newPassword = password;

    const myUser: User = this.authService.getUser();

    this.confirmationService.confirm(`common.confirmation.${ActionCV.all.UPDATE}`, null, false)
      .then((confirmResponse: ConfirmationResponse) => {
        if (confirmResponse && confirmResponse.ok) {
          this.spinner.startSpinner('Cambiando clave');
          // llamamos al servicio
          this.userService.changePassword(myUser.username, changePassword)
          .subscribe({
            next: () => {
              // acciones para el OK
              this.spinner.stopSpinner();
              const user = this.authService.getUser();
              user.passwordChangeRequired = false;
              this.authService.setUser(user);
              this.infoService.showInfo('entity.user.changePassword.actions.update.ok');
              this.activeModal.close();
              void this.router.navigate(['']);
             },
            error: () => {
              // acciones para el error
              this.spinner.stopSpinner();
              this.clearForm();
            }
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  clearForm(): void {
    this.detailForm.get('previousPassword').setValue(null);
    this.detailForm.get('password').setValue(null);
    this.detailForm.get('repeatpassword').setValue(null);
  }

  public close(): void {
    this.activeModal.close();
  }
}
